import React, { createContext, useContext, useState, useEffect } from 'react';

const FavoritesContext = createContext();

export const useFavorites = () => useContext(FavoritesContext);

export const FavoritesProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try {
      const saved = localStorage.getItem('lr_favorites');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('lr_favorites', JSON.stringify(ids));
  }, [ids]);

  const toggle = (bookId) =>
    setIds((prev) => (prev.includes(bookId) ? prev.filter((i) => i !== bookId) : [...prev, bookId]));

  const isFav = (bookId) => ids.includes(bookId);

  return (
    <FavoritesContext.Provider value={{ ids, toggle, isFav, count: ids.length }}>
      {children}
    </FavoritesContext.Provider>
  );
};
